// extracted by mini-css-extract-plugin
export default {"content":"BasePage_content__JNUoR"};